import React from 'react';
import {Input, InputGroup, InputGroupText, Label} from "reactstrap";
import Select from "react-select";
import {Glob as G} from "../../libs/Glob.mjs";

const options = ['p','div','h2','h3','h4','h5','h6','hr'].map( x => ({ label: x, value: x }));

const EditorSubdHeaderFooter = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			orig: this.props.value[this.props.selector] || {},
			value: this.props.value[this.props.selector] ? G.clone(this.props.value[this.props.selector]) : undefined
		};
		this.uid = G.generateUid(this.props.selector);
	}
	render() {
		return (
			<InputGroup
				disabled={ ! this.state.value }
				className={"SubfieldHeaderFooter "+this.props.selector}
			>
				<InputGroupText>
					<Input
						value={JSON.stringify(this.state.orig)}
						checked={!! this.state.value }
						id={ this.uid }
						onChange={e => {
							const v = e.target.checked ? JSON.parse(e.target.value) : undefined;
							this.setState({ value: v } );
							this.props.setValue(this.props.selector, v);
						}}
						type={"checkbox"}
					/>
				</InputGroupText>
				<InputGroupText>
					<Label htmlFor={ this.uid }>
						{ this.props.selector }
					</Label>
				</InputGroupText>
				<Select
					options={options}
					isDisabled={! this.state.value}
					defaultValue={options.find(x => (x.value === (this.state.value?.node || 'p')))}
					value={options.find(x => (x.value === (this.state.value?.node || 'p')))}
					onChange={sv => {
						const h = this.state.value || {};
						h.node = sv.value;
						this.setState({ value: h });
						this.props.setValue(this.props.selector, h);
					}}
				/>
				<Input
					disabled={!this.state.value || this.state.value?.node === 'hr'}
					value={this.state.value?.text ?? ''}
					onChange={event => {
						const h = this.state.value || {};
						h.text = event.target.value;
						this.setState({ value: h });
						this.props.setValue(this.props.selector, h);
					}}
				/>
			</InputGroup>
		)
	}
}

export default EditorSubdHeaderFooter;